/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_Feat1Inputs */

const en_fac_plan_feat1 = /** @type {(inputs: Fac_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 Design Rooms / month, 40 participants each`)
};

const id_fac_plan_feat1 = /** @type {(inputs: Fac_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 Design Room / bulan, 40 peserta per ruang`)
};

/**
* | output |
* | --- |
* | "30 Design Rooms / month, 40 participants each" |
*
* @param {Fac_Plan_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_feat1 = /** @type {((inputs?: Fac_Plan_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_feat1(inputs)
	return en_fac_plan_feat1(inputs)
});